import styled, {css} from "styled-components";

export const StyledGoodsSlider = styled.div`

    height: 100%;
    width: 100%;
    .swiper-slide {
        height: 100% !important;     /* вместо height: inherit */
        //margin: 0 !important;        /* временно убери margin */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .swiper-initialized {
        height: 100% !important;     /* вместо max-height: inherit */
    }

`